import { Route, Switch, Redirect } from 'react-router-dom';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';

import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import authorizationService from 'common/services/security/authorizationService';
import { useSelector } from 'react-redux';
import { getEnablePerformanceTest } from 'features/project/projectSlice';
import PerformanceTestPage from './PerformanceTestPage';

/*  This page is for the Netherlands team to test the perfomance of Sharepoint downloads.
  This may be removed in the future.
*/

const PerformanceTestPageRouter = () => {
  const isPerfTestEnabled = useSelector(getEnablePerformanceTest);
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const hasValidToken = authorizationService.hasValidToken();

  if (isPerfTestEnabled === null) return null;

  return (
    <>
      <Switch>
        <Route
          exact
          path="/projects/:projectId/e729cc9b-fcee-4d70-9eae-9884dc421714"
        >
          {hasValidToken && isPwcUser && isPerfTestEnabled ? (
            <PerformanceTestPage />
          ) : (
            <Redirect to="/" />
          )}
        </Route>
      </Switch>
    </>
  );
};

export default PerformanceTestPageRouter;
